export function toPath(key: string) {
  let w = '';
  const r = [];
  let i = 0;
  for (; i < key.length; i++) {
    const ch = key.charAt(i);
    if (ch === '.' || ch === '[' || ch === ']') {
      if (w) {
        r.push(w);
      }
      w = '';
    } else {
      w += ch;
    }
  }

  if (w) {
    r.push(w);
  }
  return r;
}

type keyOrPath = string | string[];

export function ensurePath(keyOrPath: keyOrPath) {
  if (typeof keyOrPath === 'string') {
    return toPath(keyOrPath);
  }
  return keyOrPath;
}

interface AnyObject {
  [field: string]: any;
}

export function set(source: AnyObject = {}, keyOrPath: keyOrPath, val: any) {
  const [key, ...path] = ensurePath(keyOrPath);
  const result: AnyObject = {
    ...source,
  };

  result[key] = path?.length ? set(result[key], path, val) : val;
  return result;
}

export function get(source: AnyObject = {}, keyOrPath: keyOrPath) {
  const path = ensurePath(keyOrPath);

  return path.reduce((parent: AnyObject, nodeKey: string) => {
    if (!parent) {
      return undefined;
    }
    return parent[nodeKey];
  }, source);
}
